/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsHoverThumbViewProps } from '../../../modules/hosports-hover-thumb/./hosports-hover-thumb';
import ScrollFadeIn from './../../../baseComponents/scroll-fade/./scroll-fade';
// @ts-ignore
import Ratio from 'react-ratio';

class HosportsHoverThumb extends React.Component<IHosportsHoverThumbViewProps> {
  render() {
    const { config } = this.props;
    let positionClass = '';
    if(config.textPosition){
      positionClass = cssClassCoversionDictionary[config.textPosition]
    }
    return (
      <ScrollFadeIn>
        <div className={'hosports-hover-thumb '+config.theme}>
          <div className={'hosports-hover-text-container '+positionClass}>
            {config.title && <h4 className={'hosports-hover-thumb-title'}>{config.title}</h4>}
          </div>
          {config.hoverLine && <div className={'hosports-hover-thumb-hover-line'} style={{background:"#123456"}} />}
          <div className={'hosports-hover-thumb-tint'} />
          {config.image &&
            <div className="hosports-hover-thumb-image-container">
              <Ratio ratio={ 1 / 1 }>
                <div className="hosports-hover-thumb-image background-image-fill" style={{backgroundImage:"url("+config.image.src+")"}} />
              </Ratio>
            </div>
          }
        </div>
      </ScrollFadeIn>
    );
  }
}

export const cssClassCoversionDictionary = {
  centerCenter:'center-center',
  leftCenter:'left-center',
  rightCenter:'right-center',
  bottomLeft:'bottom-left',
  bottomRight:'bottom-right',
  bottomCenter:'bottom-center',
  topLeft:'top-left',
  topRight:'top-right',
  topCenter:'top-center'
};

export default HosportsHoverThumb;
